const getAuthToken = function () {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; connect.sid=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}

exports.getAuthToken = getAuthToken